import primaryButton from '../../../../primary-button';

const custom = (params) => primaryButton.solidIcon.background.disabled.custom(params);

export default custom;
